var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-form", [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12 col-sm-6" },
            [
              _c("card-title-component", {
                attrs: { title: _vm.$t("ceremony.location.ceremony-title") }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "card-content" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "" } },
                        [
                          _c(
                            "b-form-radio-group",
                            {
                              staticClass: "location-radio-group",
                              attrs: {
                                id: "radiosCeremony",
                                name: "radioSubComponentCeremony"
                              },
                              model: {
                                value: _vm.localLocationTypeCeremony,
                                callback: function($$v) {
                                  _vm.localLocationTypeCeremony = $$v
                                },
                                expression: "localLocationTypeCeremony"
                              }
                            },
                            [
                              _c(
                                "b-form-radio",
                                { attrs: { value: "church" } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("ceremony.location.church"))
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("b-form-input", {
                                staticClass: "o-form",
                                attrs: {
                                  id: "church-text-input-ceremony",
                                  type: "text",
                                  required: "",
                                  placeholder: _vm.$t(
                                    "ceremony.location.locationPlaceholder"
                                  ),
                                  disabled:
                                    _vm.localLocationTypeCeremony != "church"
                                },
                                model: {
                                  value: _vm.localChurchTextCeremony,
                                  callback: function($$v) {
                                    _vm.localChurchTextCeremony = $$v
                                  },
                                  expression: "localChurchTextCeremony"
                                }
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "gap" }),
                              _vm._v(" "),
                              _c(
                                "b-form-radio",
                                { attrs: { value: "nature" } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("ceremony.location.nature"))
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("b-form-input", {
                                staticClass: "o-form",
                                attrs: {
                                  id: "nature-text-input-ceremony",
                                  type: "text",
                                  required: "",
                                  placeholder: _vm.$t(
                                    "ceremony.location.locationPlaceholder"
                                  ),
                                  disabled:
                                    _vm.localLocationTypeCeremony != "nature"
                                },
                                model: {
                                  value: _vm.localNatureTextCeremony,
                                  callback: function($$v) {
                                    _vm.localNatureTextCeremony = $$v
                                  },
                                  expression: "localNatureTextCeremony"
                                }
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "gap" }),
                              _vm._v(" "),
                              _c(
                                "b-form-radio",
                                { attrs: { value: "restaurantClub" } },
                                [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(
                                        _vm.$t(
                                          "ceremony.location.restaurantClub"
                                        )
                                      ) +
                                      "\n                                    "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("b-form-input", {
                                staticClass: "o-form",
                                attrs: {
                                  id: "club-text-input",
                                  type: "text",
                                  required: "",
                                  placeholder: _vm.$t(
                                    "ceremony.location.locationPlaceholder"
                                  ),
                                  disabled:
                                    _vm.localLocationTypeCeremony !=
                                    "restaurantClub"
                                },
                                model: {
                                  value: _vm.localRestaurantClubTextCeremony,
                                  callback: function($$v) {
                                    _vm.localRestaurantClubTextCeremony = $$v
                                  },
                                  expression: "localRestaurantClubTextCeremony"
                                }
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "gap" }),
                              _vm._v(" "),
                              _c(
                                "b-form-radio",
                                { attrs: { value: "otherLocation" } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("ceremony.location.other")) +
                                      "\n                                    "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("b-form-input", {
                                staticClass: "o-form",
                                attrs: {
                                  id: "location-other-text-input-ceremony",
                                  type: "text",
                                  required: "",
                                  placeholder: _vm.$t(
                                    "ceremony.location.locationPlaceholder"
                                  ),
                                  disabled:
                                    _vm.localLocationTypeCeremony !=
                                    "otherLocation"
                                },
                                model: {
                                  value: _vm.localLocationOtherTextCeremony,
                                  callback: function($$v) {
                                    _vm.localLocationOtherTextCeremony = $$v
                                  },
                                  expression: "localLocationOtherTextCeremony"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 col-sm-6" },
            [
              _c("card-title-component", {
                attrs: { title: _vm.$t("ceremony.location.observance-title") }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "card-content" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "" } },
                        [
                          _c(
                            "b-form-radio-group",
                            {
                              staticClass: "location-radio-group",
                              attrs: {
                                id: "radiosObservance",
                                name: "radioSubComponentObservance"
                              },
                              model: {
                                value: _vm.localLocationTypeObservance,
                                callback: function($$v) {
                                  _vm.localLocationTypeObservance = $$v
                                },
                                expression: "localLocationTypeObservance"
                              }
                            },
                            [
                              _c(
                                "b-form-radio",
                                { attrs: { value: "church" } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("ceremony.location.church"))
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("b-form-input", {
                                staticClass: "o-form",
                                attrs: {
                                  id: "church-text-input-observance",
                                  type: "text",
                                  required: "",
                                  placeholder: _vm.$t(
                                    "ceremony.location.locationPlaceholder"
                                  ),
                                  disabled:
                                    _vm.localLocationTypeObservance != "church"
                                },
                                model: {
                                  value: _vm.localChurchTextObservance,
                                  callback: function($$v) {
                                    _vm.localChurchTextObservance = $$v
                                  },
                                  expression: "localChurchTextObservance"
                                }
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "gap" }),
                              _vm._v(" "),
                              _c(
                                "b-form-radio",
                                { attrs: { value: "nature" } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("ceremony.location.nature"))
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("b-form-input", {
                                staticClass: "o-form",
                                attrs: {
                                  id: "nature-text-input-observance",
                                  type: "text",
                                  required: "",
                                  placeholder: _vm.$t(
                                    "ceremony.location.locationPlaceholder"
                                  ),
                                  disabled:
                                    _vm.localLocationTypeObservance != "nature"
                                },
                                model: {
                                  value: _vm.localNatureTextObservance,
                                  callback: function($$v) {
                                    _vm.localNatureTextObservance = $$v
                                  },
                                  expression: "localNatureTextObservance"
                                }
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "gap" }),
                              _vm._v(" "),
                              _c(
                                "b-form-radio",
                                { attrs: { value: "restaurantClub" } },
                                [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(
                                        _vm.$t(
                                          "ceremony.location.restaurantClub"
                                        )
                                      ) +
                                      "\n                                    "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("b-form-input", {
                                staticClass: "o-form",
                                attrs: {
                                  id: "club-text-input-observance",
                                  type: "text",
                                  required: "",
                                  placeholder: _vm.$t(
                                    "ceremony.location.locationPlaceholder"
                                  ),
                                  disabled:
                                    _vm.localLocationTypeObservance !=
                                    "restaurantClub"
                                },
                                model: {
                                  value: _vm.localRestaurantClubTextObservance,
                                  callback: function($$v) {
                                    _vm.localRestaurantClubTextObservance = $$v
                                  },
                                  expression:
                                    "localRestaurantClubTextObservance"
                                }
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "gap" }),
                              _vm._v(" "),
                              _c(
                                "b-form-radio",
                                { attrs: { value: "otherLocation" } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("ceremony.location.other")) +
                                      "\n                                    "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("b-form-input", {
                                staticClass: "o-form",
                                attrs: {
                                  id: "location-other-text-input-observance",
                                  type: "text",
                                  required: "",
                                  placeholder: _vm.$t(
                                    "ceremony.location.locationPlaceholder"
                                  ),
                                  disabled:
                                    _vm.localLocationTypeObservance !=
                                    "otherLocation"
                                },
                                model: {
                                  value: _vm.localLocationOtherTextObservance,
                                  callback: function($$v) {
                                    _vm.localLocationOtherTextObservance = $$v
                                  },
                                  expression: "localLocationOtherTextObservance"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ])
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12 col-sm-6" },
            [
              _c("card-title-component", {
                attrs: { title: _vm.$t("ceremony.food.title") }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "card-content" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "o-label",
                          attrs: {
                            id: "apero-form-group",
                            label: _vm.$t("ceremony.food.apero"),
                            "label-for": "apero-input"
                          }
                        },
                        [
                          _c("b-form-input", {
                            staticClass: "o-form",
                            attrs: {
                              id: "apero-input",
                              type: "text",
                              required: "",
                              placeholder: _vm.$t("ceremony.food.apero")
                            },
                            model: {
                              value: _vm.localApero,
                              callback: function($$v) {
                                _vm.localApero = $$v
                              },
                              expression: "localApero"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "o-label",
                          attrs: {
                            id: "menu-form-group",
                            label: _vm.$t("ceremony.food.menu"),
                            "label-for": "menu-input"
                          }
                        },
                        [
                          _c("b-form-input", {
                            staticClass: "o-form",
                            attrs: {
                              id: "menu-input",
                              type: "text",
                              required: "",
                              placeholder: _vm.$t("ceremony.food.menu")
                            },
                            model: {
                              value: _vm.localMenu,
                              callback: function($$v) {
                                _vm.localMenu = $$v
                              },
                              expression: "localMenu"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "o-label",
                          attrs: {
                            id: "beverages-form-group",
                            label: _vm.$t("ceremony.food.beverages"),
                            "label-for": "beverages-input"
                          }
                        },
                        [
                          _c("b-form-input", {
                            staticClass: "o-form",
                            attrs: {
                              id: "beverages-input",
                              type: "text",
                              required: "",
                              placeholder: _vm.$t("ceremony.food.beverages")
                            },
                            model: {
                              value: _vm.localBeverages,
                              callback: function($$v) {
                                _vm.localBeverages = $$v
                              },
                              expression: "localBeverages"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "o-label",
                          attrs: {
                            id: "dishes-misc-form-group",
                            label: _vm.$t("ceremony.food.dishesMisc"),
                            "label-for": "dishes-misc-input"
                          }
                        },
                        [
                          _c("b-form-input", {
                            staticClass: "o-form",
                            attrs: {
                              id: "dishes-misc-input",
                              type: "text",
                              required: "",
                              placeholder: _vm.$t("ceremony.food.dishesMisc")
                            },
                            model: {
                              value: _vm.localDishesMisc,
                              callback: function($$v) {
                                _vm.localDishesMisc = $$v
                              },
                              expression: "localDishesMisc"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 col-sm-6" },
            [
              _c("card-title-component", {
                attrs: { title: _vm.$t("ceremony.decoration.title") }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "card-content" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "o-label",
                          attrs: {
                            id: "ceremony-flowers-form-group",
                            label: _vm.$t(
                              "ceremony.decoration.ceremonyFlowers"
                            ),
                            "label-for": "ceremony-flowers-input"
                          }
                        },
                        [
                          _c("b-form-input", {
                            staticClass: "o-form",
                            attrs: {
                              id: "ceremony-flowers-input",
                              type: "text",
                              required: "",
                              placeholder: _vm.$t(
                                "ceremony.decoration.ceremonyFlowers"
                              )
                            },
                            model: {
                              value: _vm.localCeremonyFlowers,
                              callback: function($$v) {
                                _vm.localCeremonyFlowers = $$v
                              },
                              expression: "localCeremonyFlowers"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "o-label",
                          attrs: {
                            id: "observance-flowers-form-group",
                            label: _vm.$t(
                              "ceremony.decoration.observanceFlowers"
                            ),
                            "label-for": "observance-flowers-input"
                          }
                        },
                        [
                          _c("b-form-input", {
                            staticClass: "o-form",
                            attrs: {
                              id: "observance-flowers-input",
                              type: "text",
                              required: "",
                              placeholder: _vm.$t(
                                "ceremony.decoration.observanceFlowers"
                              )
                            },
                            model: {
                              value: _vm.localObservanceFlowers,
                              callback: function($$v) {
                                _vm.localObservanceFlowers = $$v
                              },
                              expression: "localObservanceFlowers"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "o-label",
                          attrs: {
                            id: "observance-decoration-form-group",
                            label: _vm.$t(
                              "ceremony.decoration.observanceDecoration"
                            ),
                            "label-for": "observance-decoration-input"
                          }
                        },
                        [
                          _c("b-form-input", {
                            staticClass: "o-form",
                            attrs: {
                              id: "observance-decoration-input",
                              type: "text",
                              required: "",
                              placeholder: _vm.$t(
                                "ceremony.decoration.observanceDecoration"
                              )
                            },
                            model: {
                              value: _vm.localObservanceDecoration,
                              callback: function($$v) {
                                _vm.localObservanceDecoration = $$v
                              },
                              expression: "localObservanceDecoration"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "o-label",
                          attrs: {
                            id: "decoration-misc-form-group",
                            label: _vm.$t("ceremony.decoration.decorationMisc"),
                            "label-for": "decoration-misc-input"
                          }
                        },
                        [
                          _c("b-form-input", {
                            staticClass: "o-form",
                            attrs: {
                              id: "decoration-misc-input",
                              type: "text",
                              required: "",
                              placeholder: _vm.$t(
                                "ceremony.decoration.decorationMisc"
                              )
                            },
                            model: {
                              value: _vm.localDecorationMisc,
                              callback: function($$v) {
                                _vm.localDecorationMisc = $$v
                              },
                              expression: "localDecorationMisc"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ])
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12 col-sm-6" },
            [
              _c("card-title-component", {
                attrs: { title: _vm.$t("ceremony.music.title") }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "card-content" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [_c("musics-container-component")],
                    1
                  )
                ])
              ])
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col button-div" },
          [
            _c(
              "b-button",
              { staticClass: "save-button o-button", on: { click: _vm.save } },
              [_vm._v("\n                Speichern\n            ")]
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ca3182ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ca3182ba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/funeral/CeremonyComponent.vue
// module id = null
// module chunks = 